import {
  IUserType,
  UserState,
} from '../../../../../../../../../contexts/User/UserContext';
import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';

interface IGetClickHandlerArgs {
  joinHandler: Function;
  cancelHandler: Function;
  userType: IUserType;
}

export function getJoinClickHandler({
  joinHandler,
  userType,
  cancelHandler,
}: IGetClickHandlerArgs): Function {
  switch (userType) {
    case UserState.VISITOR:
    case UserState.MEMBER:
    case ParticipantState.AUTO_REMOVED:
    case ParticipantState.INVITED:
    case ParticipantState.PAYMENT_REQUESTED:
    case ParticipantState.PAYMENT_STARTED:
    case ParticipantState.REMOVED:
    case ParticipantState.LEFT:
    case ParticipantState.COMPLETED:
    case ParticipantState.JOIN_REJECTED:
    case ParticipantState.FAILED:
      return joinHandler;
    case ParticipantState.JOIN_REQUESTED:
      return cancelHandler;
    case ParticipantState.JOINED:
    case ParticipantState.RUNNING:
    default:
      return () => {};
  }
}
